import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Features/Common/ErrorHandler";
import { toast } from "react-toastify";
import { GuidelineService } from "Services/axios/Guideline.Service";

export const fetchGuidelines = createAsyncThunk(
  'Guidelines/fetchGuidelines',
  async (membershipId) => {
    try {
      const response = await GuidelineService.getAll(membershipId);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const fetchGuidelineDetail = createAsyncThunk(
  'Guidelines/fetchGuidelineDetail',
  async ({ membershipId, guidelineDay }) => {
    try {
      const response = await GuidelineService.getDetail(membershipId, guidelineDay);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitGuidelines = createAsyncThunk(
  'Guidelines/submitGuidelines',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('day', data.day);
      formData.append('title', data.title);
      formData.append('membership_id', data.membershipId);

      data?.items?.forEach((item, index) => {
        formData.append(`material[${index}][title]`, item.title);
        formData.append(`material[${index}][link]`, item.link);
      });

      let response;
      if (data.isUpdate) {
        response = await GuidelineService.update(data.id, formData);
        toast.success('Guideline berhasil diperbarui', {
          position: toast.POSITION.TOP_RIGHT
        });
      } else {
        response = await GuidelineService.create(formData);
        toast.success('Guideline berhasil ditambahkan', {
          position: toast.POSITION.TOP_RIGHT
        });
      }

      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteGuidelines = createAsyncThunk(
  'Guidelines/deleteGuidelines',
  async (id) => {
    try {
      const response = await GuidelineService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return id;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);